import { Grid, Stack, Typography } from "@mui/material";
import { InstallationDatePicker } from "./InstallationDatePicker";
import { InstallationTimeSlot } from "./InstallationTimeSlot";
import { IInstallationAppointmentForm } from "./IInstallationAppointmentForm";
import { useTranslation } from "react-i18next";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { InstallationAppointmentSkeleton } from "./InstallationAppointmentSkeleton";
import { useInstallationAppointment } from "@features/installation/useInstallationAppointment";

interface IParams {
    offerId: number;
    onFormValuesChange?: (values: IInstallationAppointmentForm | null) => void;
    initialValues?: {
        appointmentDate: Date | null;
        timeSlot: string;
    };
}

export const InstallationAppointment = (props: IParams) => {
    const { offerId, onFormValuesChange, initialValues } = props;
    const { t } = useTranslation("installation");

    const { dateList, isLoading, error, formMethods } = useInstallationAppointment({
        offerId,
        initialValues,
        onFormValuesChange,
    });

    return (
        <Stack gap={1}>
            <Typography color="secondary" variant="normal">
                {t("bookInstallationInfos")}
            </Typography>
            <Typography color="secondary" variant="normal">
                {t("takeFewMoment")}
            </Typography>
            <HandleErrorAndLoading error={error} isLoading={isLoading} skeleton={<InstallationAppointmentSkeleton />}>
                <Grid container spacing={3}>
                    <Grid item md={6} xs={12}>
                        <InstallationDatePicker
                            availableDateList={dateList}
                            formMethods={formMethods}
                            fullWidth
                            isLoading={isLoading}
                        />
                    </Grid>
                    <Grid item md={6} xs={12}>
                        <InstallationTimeSlot availableDateList={dateList} formMethods={formMethods} fullWidth />
                    </Grid>
                </Grid>
            </HandleErrorAndLoading>
        </Stack>
    );
};
